export default {
  async asyncData({ $axios, params }) {
    let map = {};
    try{
      const htmlfile = params.id;
      let res = await $axios.get('/api/news/info', { params: { htmlfile, type: 'map' } });
      map = res.data;
    }catch(e) {
      console.log(e)
    }

    return { map }
  },
  head() {
    let title = this.map.title;
    let description = this.map.seo_description ? { hid: 'description', name: 'description', content: this.map.seo_description } : null;
    let keyword = this.map.seo_keyword ? { hid: 'keyword', name: 'keyword', content: this.map.seo_keyword } : null;
    let meta = [];
    if(description) {
      meta[0] = description;
    }
    if(keyword) {
      meta[1] = keyword;
    }
    return {
      title,
      meta
    }
  }
}
